import { useEffect, useId, useRef, type ReactNode } from 'react';

export function Modal({
  title,
  onClose,
  children,
  busy = false,
  sheet = false,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  busy?: boolean;
  sheet?: boolean;
}): React.JSX.Element {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current!;
    dialog.showModal();
    return () => dialog.close();
  }, []);
  return (
    <dialog
      ref={ref}
      aria-labelledby={titleId}
      className={`app-dialog ${sheet ? 'app-dialog--sheet' : ''}`}
      onCancel={(event) => {
        event.preventDefault();
        if (!busy) onClose();
      }}
    >
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 id={titleId} className="section-title">
          {title}
        </h2>
        <button
          type="button"
          className="btn btn--ghost"
          disabled={busy}
          onClick={onClose}
          aria-label="閉じる"
        >
          ✕
        </button>
      </div>
      {children}
    </dialog>
  );
}
